export enum ActionTypes {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  SELECT = 'SELECT',
  UNSELECT = 'UNSELECT',
  LOAD_COMPLETED = 'LOAD_COMPLETED',
  CREATE_COMPLETED = 'CREATE_COMPLETED',
  EDIT_COMPLETED = 'EDIT_COMPLETED',
  DELETE_COMPLETED = 'DELETE_COMPLETED',
}

export type AwsCredential = {
  accessKey: string;
  secretAccessKey: string;
  secretToken?: string;
};

export type AzureLoadFile = {
  fileName: string;
  content: string;
};

export type AzureLoadFiles = {
  inventory: AzureLoadFile;
  report?: AzureLoadFile;
};

/**
 * Scan input held while the user confirms starting the scan: AWS credentials,
 * Azure files to load, or neither for instance-profile scans.
 */
export type PendingScan = {
  credential?: AwsCredential;
  azureFiles?: AzureLoadFiles;
};
